module.exports = __webpack_public_path__ + "img/MG_2626.ea0427f3.jpg";